import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    Colors,
    CreateColorsInput,
    ModelSortDirection,
    UpdateColorsInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class ColorsService {
    private amplifyClient = generateClient();
    constructor() {}

    async listColors(): Promise<Colors[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listColors
                })
            ).data.listColors.items;
            if (data) return data as Colors[];
        } catch (error) {
            console.error('Error finding Colors:', error);
            return null;
        }
    }

    async listColorsByPosition(
        status: string = 'active',
        limit: number = 50,
        sortDirection: ModelSortDirection = ModelSortDirection.ASC
    ): Promise<Colors[]> {
        try {
            const result = (
                await this.amplifyClient.graphql({
                    query: queries.ListColorsPosition,
                    variables: { status, limit, sortDirection }
                })
            ).data.ListColorsPosition;
            return (result?.items ?? []) as Colors[];
        } catch (error) {
            console.error('Error finding Colors by position:', error);
            return [];
        }
    }

    async createClient(input: CreateColorsInput): Promise<Colors> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createColors,
                    variables: {
                        input
                    }
                })
            ).data.createColors;
            if (date) return date as Colors;
        } catch (error) {
            console.error('Error creating colors:', error);
            return null;
        }
    }

    async update(input: UpdateColorsInput): Promise<Colors> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateColors,
                    variables: {
                        input
                    }
                })
            ).data.updateColors;
            if (date) return date as Colors;
        } catch (error) {
            console.error('Error updated colors:', error);
            return null;
        }
    }
}
